import { HttpBackend, HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ICreatePreLoan, ICustomer, IPreLoan } from '@app/core/models/customer.model';
import { environment } from '@environment';
import { map } from 'rxjs/operators';
import {
  ICreateLoan,
  ICustomerValidate,
  IInstallmentsConfig,
  ILoanCreated,
} from '../../core/models/customer.model';
import { HandleTokenService } from '../../core/services/handle-token.service';
import { REQUEST_MOCK_SCORE, REQUEST_MOCK_VALIDATE, REQUEST_MOCK_VALIDATION } from '../mocks/app-control.mock';
import { ServerMock } from '../mocks/app-serve.mock';
import { URLS } from './url.constants';
import { ICustomerCard } from '../../core/models/customer.model';

const API_URL = environment.api_url;

@Injectable({
  providedIn: 'root',
})
export class CustomerAPI {
  public _httpClient = new HttpClient(this._httpBackend);
  private _localServer: ServerMock = new ServerMock();

  constructor(
    private _http: HttpClient,
    public _httpBackend: HttpBackend,
    private _handleTokenService: HandleTokenService
  ) {}

  public requestCustomerInformation(): Observable<ICustomer> {
    return this._http.get<ICustomer>(`${URLS.CUSTOMER}`);
  }

  public getCustomerCard(): Observable<ICustomerCard> {
    return this._http.get<ICustomerCard>(`${URLS.GET_CARD}`);
  }

  public requestPreLoan(offerId: string, amount: string): Observable<IInstallmentsConfig[]> {
    const { production, isTestServer } = environment;
    return production && !isTestServer
      ? this._http.get<IInstallmentsConfig[]>(`/loans/preview/?offerId=${offerId}&amount=${amount}`)
      : this._http.get<IInstallmentsConfig[]>(`/loans/preview/`);
  }

  public createPreLoans(createPreLoan: ICreatePreLoan): Observable<IPreLoan> {
    return this._http.post<IPreLoan>(`${URLS.PRE_LOANS}`, createPreLoan);
  }

  public requestUserScore(merchantTransactionId: string): Observable<ICustomerValidate> {
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_MOCK_VALIDATION;
    const token = this._handleTokenService.getAccessToken();
    const options = {
      headers: this._setHeaders(token),
    };

    return production && !isTestServer
      ? this._httpClient.post<ICustomerValidate>(
          `${API_URL}${URLS.VALIDATION_CUSTOMER}`,
          { aggregator_transaction_id: merchantTransactionId },
          options
        )
      : this._localServer.request(httpRequest).pipe(
          map((response: HttpResponse<any>) => {
            const session: ICustomerValidate = response?.body;
            return session;
          })
        );
  }

  public requestCustomerValidation(id: string): Observable<ICustomerValidate> {
    const { production, isTestServer } = environment;
    const httpRequest: any = REQUEST_MOCK_VALIDATE;
    const token = this._handleTokenService.getAccessToken();
    const options = {
      headers: this._setHeaders(token),
    };

    return production && !isTestServer
      ? this._httpClient.post<ICustomerValidate>(
          `${API_URL}${URLS.VALIDATE_CUSTOMER}`,
          { aggregator_transaction_id: id },
          options
        )
      : this._localServer.request(httpRequest).pipe(
          map((response: HttpResponse<any>) => {
            const session: ICustomerValidate = response?.body;
            return session;
          })
        );
  }

  private _setHeaders(transactionToken):
    | HttpHeaders
    | {
        [header: string]: string | string[];
      } {
    return {
      'Content-Type': 'application/json',
      Authorization: `Token: ${transactionToken}`,
    };
  }
}
